"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTriggerOrder = exports.deleteTriggerOrder = exports.queryHistoryTriggers = exports.queryActiveTriggers = void 0;
const operators_1 = require("rxjs/operators");
const utils_1 = require("./utils");
/**查询当前条件单 */
function queryActiveTriggers(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/open_triggers",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "triggers")));
}
exports.queryActiveTriggers = queryActiveTriggers;
/**查询历史条件单 */
function queryHistoryTriggers(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/closed_triggers",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "triggers")));
}
exports.queryHistoryTriggers = queryHistoryTriggers;
/**取消条件单 */
function deleteTriggerOrder(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: `/trigger/${params.triggerId}`,
        method: "DELETE",
        query: params,
    });
}
exports.deleteTriggerOrder = deleteTriggerOrder;
/** 创建条件单 */
function createTriggerOrder(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trigger",
        method: "POST",
        data: params,
    });
}
exports.createTriggerOrder = createTriggerOrder;
